import React,{ useState } from 'react';
import './Cart.css';
import CartItem from '../CartItem/CartItem';

const Cart = (props) => {
     const { selectedProducts, removeItem, clearList } = props;

    //  console.log(selectedProducts);

   const selectRandom = () => {
        if (selectedProducts.length > 0) {
            const max = selectedProducts.length;
            const random = Math.floor(Math.random() * (max - 1));
        alert(selectedProducts[random].name + '\n' + selectedProducts[random].price + '\n' + selectedProducts[random].shipping);
        }
        else {
            alert('Please select some items first');
        }
    } 

    return (
        <div className="cart">
            <h3 className="text-2xl">Selected Products: {selectedProducts.length}</h3>
            <br />
            <div className="items">
                {
                    selectedProducts.map(selectedProduct => <CartItem
                        key={selectedProduct.id}
                        selectedProduct={selectedProduct}
                        removeItem={removeItem}
                    ></CartItem>)
                }
            </div>
            <button className='select-buttons' onClick={selectRandom}>Choose one for me 😊</button>
            <br />
            <button className='select-buttons' onClick={clearList}>Clear Product List</button>
            
        </div>
    );
};

export default Cart;